import * as c from "react";
import { u as A } from "./tss-DN0acMKN.mjs";
import { j as B } from "./jsx-runtime-3tyXYecC.mjs";
import { r as D, g as u } from "./utils-LGPhgRZb.mjs";
import { u as G } from "./useForkRef-C_4o__cU.mjs";
import { g as H } from "./getReactElementRef-B4Mdq17D.mjs";
import { T as J } from "./Transition-4HZvpgGj.mjs";
const K = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, X = /* @__PURE__ */ c.forwardRef(function(x, y) {
  const e = A(), h = {
    enter: e.transitions.duration.enteringScreen,
    exit: e.transitions.duration.leavingScreen
  }, {
    addEndListener: l,
    appear: g = !0,
    children: s,
    easing: f,
    in: m,
    onEnter: p,
    onEntered: R,
    onEntering: T,
    onExit: E,
    onExited: w,
    onExiting: F,
    style: a,
    timeout: d = h,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: P = J,
    ...j
  } = x, r = c.useRef(null), L = G(r, H(s), y), i = (t) => (n) => {
    if (t) {
      const o = r.current;
      n === void 0 ? t(o) : t(o, n);
    }
  }, k = i(T), v = i((t, n) => {
    D(t);
    const o = u({
      style: a,
      timeout: d,
      easing: f
    }, {
      mode: "enter"
    });
    t.style.webkitTransition = e.transitions.create("opacity", o), t.style.transition = e.transitions.create("opacity", o), p && p(t, n);
  }), C = i(R), S = i(F), b = i((t) => {
    const n = u({
      style: a,
      timeout: d,
      easing: f
    }, {
      mode: "exit"
    });
    t.style.webkitTransition = e.transitions.create("opacity", n), t.style.transition = e.transitions.create("opacity", n), E && E(t);
  }), z = i(w), q = (t) => {
    l && l(r.current, t);
  };
  return /* @__PURE__ */ B.jsx(P, {
    appear: g,
    in: m,
    nodeRef: r,
    onEnter: v,
    onEntered: C,
    onEntering: k,
    onExit: b,
    onExited: z,
    onExiting: S,
    addEndListener: q,
    timeout: d,
    ...j,
    children: (t, n) => /* @__PURE__ */ c.cloneElement(s, {
      style: {
        opacity: 0,
        visibility: t === "exited" && !m ? "hidden" : void 0,
        ...K[t],
        ...a,
        ...s.props.style
      },
      ref: L,
      ...n
    })
  });
});
export {
  X as F
};
//# sourceMappingURL=Fade-B7C8Y6jW.mjs.map
